/**
 * Returns if the current url is reports page.
 */
const isReportsUrl = (location: any = window.location) => {
  return location.pathname.includes('/reports');
};

export default isReportsUrl;
